import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { UserProofComponent } from '../../componentsAdmin/user-proof/user-proof.component';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-payment-proof',
  templateUrl: './payment-proof.page.html',
  styleUrls: ['./payment-proof.page.scss'],
})
export class PaymentProofPage implements OnInit {
  public columns = [];
  public rows = [];
  public isLoading = true;
  public totalPages = 1;
  public page = 1;
  private _paymentId = this.route.snapshot.queryParamMap.get('id');

  public messages = {
    emptyMessage: 'No hay registros.'
  };

  constructor(
    private httpSv: HttpService,
    private uiSv: UiServices,
    private route: ActivatedRoute,
    private modalController: ModalController
  ) { }

  async ngOnInit() {
    try{

      await this.getSearch();
      const column = [
        {name: 'Id', prop: 'id'},
        {name: 'Fecha', prop: 'date'}, 
        {name: 'Email', prop: 'email'},
        {name: 'Monto', prop: 'amount' }, 
        {name: 'Nro. de orden', prop: 'numberOrder'},
        {name: 'Banco receptor', prop: 'receivingBank'},
        {name: 'Referencia', prop: 'reference'},
        {name: 'Estado', prop: 'state'},
        {name: 'Leido', prop: 'view'},
        {name: 'Acciones', prop: 'showMore'},
      ];
      this.columns = column;
      this.isLoading = false;

      if(this._paymentId){
        const body = {
          id: this._paymentId
        }
        setTimeout(() => {
          const interval = setInterval(async () => {
            const existModal = await this.modalController.getTop();
            if(!existModal){
              clearInterval(interval);
              await this.openModal(body);
            }
          }, 200)
        }, 1000)
      }
    }catch(err){
      console.error(err);
    }
  }

  async getSearch(){
    const params = {
      pag: this.page
    }
    const res: any = await this.httpSv.itemIndex('paymentProof', '', params);
    const data = res.data;
    const userData = data.data;
    this.totalPages = data.meta.last_page;
    userData.map((item) => {
      item.state = item.state === 1 ? 'Aprobado' : item.state === 2 ? 'Rechazado' : 'Pendiente';
      item.view = item.view ? 'Leido' : 'Sin leer'
      item.showMore = 'Ver más';
      item.amount = `$${item.amount}`;
    });

    this.rows = userData;
  }

  async getClick(ev){
    if(ev.type === 'click'){
      let columnName = ev.column.name;
      const id = ev.row.id;
      const user = this.rows.find(user => user.id === id);
      if(columnName === 'Acciones'){
        this.openModal(user);
      }else{
        return false;
      }
    }
  }

  async openModal(user){
    const { data } = await this.uiSv.showModal(
      UserProofComponent, 
      { userId: user.id }, 
      'userProof', false
    );
    if(!data){
      return;
    }
    await this.getSearch();
  }

  getRowClass(row) {
    setTimeout(() => {
      const elementsVer = document.querySelectorAll(`[title="Ver más"]`);
      elementsVer.forEach(node => {
        node.classList.add('rolSpan');
      });
    })
    return;
  }

  changePage(event){
    this.page = event;
    this.getSearch();
  }

}
